import { render } from "./debug-console.vue?vue&type=template&id=097a45ae&scoped=true"
import script from "./debug-console.vue?vue&type=script&lang=js"
export * from "./debug-console.vue?vue&type=script&lang=js"

import "./debug-console.vue?vue&type=style&index=0&id=097a45ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097a45ae"]])

export default __exports__